import React from 'react';
import { string } from 'prop-types';

import IconInfo from '@assets/Icon/svg/Info';
import { colors, OverlayTrigger, Tooltip } from '@ajaibid/components';

const TooltipAcceleratedBoard = ({ overlayPosition }) => (
  <OverlayTrigger
    placement={overlayPosition}
    overlay={
      <Tooltip>
        Papan Akselerasi adalah Papan Pencatatan yang disediakan untuk mencatat saham dari emiten
        dengan Aset Skala Kecil hingga Aset Skala Menengah. Saham dalam papan ini belum memenuhi
        syarat untuk masuk ke Papan Pengembangan dan Papan Utama.
      </Tooltip>
    }
  >
    <IconInfo size={20} color={colors.AJAIB_BLUE_6} data-testid="iconAcceleratedBoard" />
  </OverlayTrigger>
);

TooltipAcceleratedBoard.propTypes = {
  overlayPosition: string,
};

TooltipAcceleratedBoard.defaultProps = {
  overlayPosition: 'top',
};

export default TooltipAcceleratedBoard;
